import {
    DeleteOutlined,
    EditFilled,
    ExclamationCircleOutlined,
    ZoomInOutlined
} from "@ant-design/icons";
import { Button, Col, Image, Modal, Tag, Spin } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../../services/authApi";
import Paginate from "./../../../commons/Paginate";
import MainLayout from "./../../../components/mainLayout";
import "./index.scss";
import { ROOT_URL } from "../../../constants/api";
import { Link } from "react-router-dom";
import { nofication } from "./../../../commons/Nofication";
import moment from "moment";
const Register = () => {
    const [ordersList, setOrdersList] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [paginateCurrent, setPaginateCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [datashow, setDatashow] = useState({});
    const [dataDetail, setDataDetail] = useState([]);
    const [ids, setIds] = useState([]);

    useEffect(() => {
        fetchData();
    }, [paginateCurrent, perPage, searchValue]);

    const fetchData = () => {
        console.log(searchValue);
        const urlParams = `page=${paginateCurrent}&perPage=${perPage}&status=${searchValue.status ? searchValue.status : ''}&startDate=${searchValue.startDate ? searchValue.startDate : ''}&endDate=${searchValue.endDate ? searchValue.endDate : ''}`;
        authApis
            .getOrderList(urlParams)
            .then((data) => {
                setOrdersList(data.data.data ?? []);
                setTotalItem(data.data.total ?? 0);
                setIsLoading(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onDelete = (id) => {
        authApis
            .deleteContact(id)
            .then((data) => {

                nofication("success", "Thành công!", "Xóa dữ liệu thành công!");
                fetchData();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };
    const onConfirmDelete = (id) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "Bạn không có quyền xóa?",
            okText: "Ok",
            cancelText: "Cancel",
            onOk: () => {
                // onDelete(id);
            },
            onCancel() {
                return;
            },
        });
    };
    const openModal = (id) => {
        setDatashow(ordersList.find((item => item.id === id)));
        authApis
            .detailOrder(id)
            .then((data) => {
                setDataDetail(data.data.listProducts);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy chi tiết đơn hàng thất bại");
            });
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const select = (id, e) => {
        if (e.target.checked === true) {
            setIds([...ids, id]);
        } else {
            setIds([...ids.filter((item => item !== id))]);
        }
    };

    const handleChange = (itemId, event) => {
        const { value } = event.target;
        itemId.type = parseInt(value);
        const updatedItems = ordersList.map((item) =>
            item.id === itemId ? { ...item, type: value } : item
        );
        setOrdersList(updatedItems);
        updateStatus(itemId);
    };

    const updateStatus = (itemId) => {
        authApis
            .updateStatus(itemId)
            .then((data) => {
                nofication("success", "Thành công", "Cập nhật trạng thái đơn hàng thành công");
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Cập nhật trạng thái đơn hàng thất bại");
            });
    }

    return (
        <MainLayout
            isShowActionHeader={true}
            title="Orders"
            link="/orders/"
            titleNew="New Order / List"
            setSearchValue={setSearchValue}
            isCreate={false}
            isHiddenAction={true}
            isOrder={true}
            ids={ids}
            setIds={setIds}
        >
            <Modal title="Thông tin đơn hàng" onOk={handleOk} onCancel={handleCancel} visible={isModalVisible}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between"
                }}>
                    <p><b>Tên:</b> {datashow.name}</p>
                    <p><b>Phone:</b> {datashow.phone}</p>
                    <p><b>Date:</b> {moment(datashow.created_at).format('DD-MM-YY HH:mm:ss')}</p>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">STT</th>
                            <th scope="col">Hình ảnh</th>
                            <th scope="col">Sản phẩm</th>
                            <th scope="col">Số lượng</th>
                            <th scope="col">Màu sắc</th>
                            <th scope="col">Loại</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataDetail.length ? (
                            dataDetail.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            {parseInt(index) + 1}
                                        </td>
                                        <td>
                                            <img style={{ width: "40px" }} src={item.images} alt="" />
                                        </td>
                                        <td style={{ width: "250px" }}>
                                            {item.title}
                                        </td>
                                        <td>
                                            {item.number}
                                        </td>
                                        <td>
                                            {item.colorProduct}
                                        </td>
                                        <td>
                                            {item.styleProduct}
                                        </td>
                                    </tr>
                                )
                            })) : ""}
                    </tbody>
                </table>
            </Modal>
            <Spin spinning={isLoading} >
                <Col span={24} className='main-min-height-table'>
                    <div
                        style={{
                            width: "100%",
                            margin: "20px 10px 0px 0px",
                            padding: "20px",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                            background: "white",
                        }}
                        className="table"
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Select</th>
                                    <th scope="col" style={{ width: "100px" }}>Date</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Phone</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Method Pay</th>
                                    <th scope="col">Total</th>
                                    <th scope="col">Discount</th>
                                    <th scope="col">Code Discount</th>
                                    <th scope="col" style={{ width: "200px" }}>Address</th>
                                    <th scope="col">Note</th>
                                    <th scope="col">Note AD</th>
                                    <th scope="col">TK PAY</th>
                                    <th scope="col">Platform</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ordersList.length ? (
                                    ordersList.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">
                                                    <input type="checkbox" onClick={(e) => select(item.id, e)} />
                                                </th>
                                                <th scope="row">{moment(item.created_at).format('DD-MM-YY HH:mm:ss')}</th>
                                                <td>
                                                    {/* //0: don moi //1: nhan don, xu ly //2: giao van chuyen //3: huy don //4: bom don 5:// hoan thanh */}
                                                    <select name="" id="" value={item.type} onChange={(event) => handleChange(item, event)}>
                                                        <option value="0">Đơn mới</option>
                                                        <option value="1">Đang xử lý</option>
                                                        <option value="2">Giao vận chuyển</option>
                                                        <option value="3">Hủy đơn</option>
                                                        <option value="4">Bom đơn</option>
                                                        <option value="5">Hoàn thành</option>
                                                    </select>
                                                </td>
                                                <th scope="row">
                                                    {item.name}
                                                </th>
                                                <td>
                                                    {item.phone}
                                                </td>
                                                <td>
                                                    {item.email}
                                                </td>
                                                <td>
                                                    {item.methodPay == 2 ? "Chuyển khoản" : "COD"}
                                                </td>
                                                <td>
                                                    {item.total.toLocaleString('vi-VN', {
                                                        style: 'currency',
                                                        currency: 'VND',
                                                    })}
                                                </td>
                                                <td>
                                                    {item.discount.toLocaleString('vi-VN', {
                                                        style: 'currency',
                                                        currency: 'VND',
                                                    })}
                                                </td>
                                                <td>{item.codeDiscount}</td>
                                                <td>{item.address + "-" + item.xa + "-" + item.huyen + "-" + item.tinh}</td>
                                                <td>{item?.ghichu}</td>
                                                <td>{item?.ghichuAd}</td>
                                                <td>{item.bankPay == 1 ? "TK Thắng" : item.bankPay == 2 ? "TK Mạnh" : item.bankPay == 3 ? "TK Tuấn" : ""}</td>
                                                <td>{item.platform}</td>
                                                <td>
                                                    {/* <Link
                                                        to={`/contact/detail/${item.id}`}
                                                    > */}
                                                    <Button
                                                        icon={
                                                            <ZoomInOutlined />
                                                        }
                                                        style={{
                                                            color: "white",
                                                            background:
                                                                "black",
                                                            border: "black",
                                                        }}
                                                        onClick={() =>
                                                            openModal(
                                                                item.id
                                                            )
                                                        }
                                                    ></Button>
                                                    <Link
                                                        to={`/orders/edit/${item.id}`}
                                                    >
                                                        <Button
                                                            icon={
                                                                <EditFilled />
                                                            }
                                                            style={{
                                                                color: "white",
                                                                background:
                                                                    "black",
                                                                border: "black",
                                                                marginLeft: 10,
                                                            }}
                                                        ></Button>
                                                    </Link>
                                                    {/* </Link> */}
                                                    {/* <Button
                                                        icon={
                                                            <DeleteOutlined />
                                                        }
                                                        onClick={() =>
                                                            onConfirmDelete(
                                                                item.id
                                                            )
                                                        }
                                                        style={{
                                                            color: "white",
                                                            background:
                                                                "#ab1a1a",
                                                            border: "#ab1a1a",
                                                            marginLeft: 10,
                                                        }}
                                                    ></Button> */}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        {isLoading === false ? (
                                            <td colspan="9">
                                                <h4
                                                    style={{
                                                        textAlign: "center",
                                                        margin: "20px 0px",
                                                    }}
                                                >
                                                    (No data)
                                                </h4>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div style={{
                        width: "100%",
                        padding: "20px",
                        background: "white",
                        borderBottomRightRadius: "10px",
                        borderBottomLeftRadius: "10px",
                    }}>
                        <Paginate
                            setPaginateCurrent={setPaginateCurrent}
                            setPerPage={setPerPage}
                            totalItem={totalItem}
                            currentPage={paginateCurrent}
                        />
                    </div>
                </Col>
            </Spin>
        </MainLayout>
    );
};

export default Register;
